import { Divider, FormControlLabel, FormGroup, Radio, RadioGroup, Typography } from '@mui/material';
import AreaLevelSetting from '../AreaLevelSetting';
import MorbidityRate from './MorbidityRate';
import PatientCompare from './PatientCompare';
// import WeekOfYear from '../WeekOfYear';
import PatientSetting from '../PatientSetting';
import TimeRangeSetting from '../TimeRangeSetting';
import ClusterSetting from './ClusterSetting';
import SpotMapSetting from '../SpotMapSetting';
import RenderTypeSetting from '../RenderTypeSetting';
import AreaSelectedSetting from '../AreaSelectedSetting';
import HISetting from './HISetting';
import CISetting from './CISetting';
import { useDispatch, useSelector } from 'react-redux';
import { getDengueSetting, setDengueArea } from '../../../reducer/dengueSettingSlice';
import { useEffect, useState } from 'react';


const config = {
    patient: {
        province: "1,11,51,151,400",
        amphur: "1,6,21,51,100",
        tambon: "1,2,6,11,20"
    }
}

// const setting = {
//     inum: "xxxxxx",
//     setting: [{
//         disease: "",
//         data: {
//             area: "morbidity",
//             patient: false,
//             spotmap: false,
//             cluster: false,
//             co: false,
//             nco: false
//         },
//         arealevel: "province",
//         areaselected: {
//             level: 1,
//             value: "thailand"
//         }
//     }]
// }

function DengueSetting() {
    const dispatch = useDispatch();
    const {area} = useSelector(getDengueSetting);
    // console.log(dengueSetting);
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue(area);
    }, [area])
    
    const handleSelectedRadio = (event) => {
        if (event.target.value === value) {
            dispatch(setDengueArea(""));
            // setValue("");
        } else {
            dispatch(setDengueArea(event.target.value));
            // setValue(event.target.value);
        }
    }

    return (
        <>
            <TimeRangeSetting />
            <div style={{
                position: 'relative',
                width: '100%',
                height: 'calc(100vh - 208px)',
                // backgroundColor: 'red',
                overflow: 'auto'
            }}>
                <Typography variant="subtitle1" sx={{
                    color: 'black',
                    textAlign: 'left',
                    marginTop: '10px'
                }}>
                    การแสดงผล
                </Typography>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="morbidity"
                    value={value}
                    name="radio-buttons-group"
                >
                    <FormControlLabel value="morbidity" control={<Radio onClick={handleSelectedRadio}/>} label="อัตราป่วย" />
                    <MorbidityRate checked={value === 'morbidity'} />
                    
                    <FormControlLabel value="compare" control={<Radio onClick={handleSelectedRadio}/>} label="จำนวนผู้ป่วยเทียบ" />
                    <PatientCompare checked={value === "compare"}/>
                    
                </RadioGroup>
                <Divider/>
                <FormGroup>
                    <PatientSetting config={config.patient} />
                    <SpotMapSetting />
                    <ClusterSetting />
                    <HISetting />
                    <CISetting />
                </FormGroup>
                <RenderTypeSetting />
                <AreaSelectedSetting />
                <AreaLevelSetting />
            </div>
        </>
    )
}

export default DengueSetting;